import { render, staticRenderFns } from "./NumberOfPeople.vue?vue&type=template&id=f06103f0&scoped=true&"
import script from "./NumberOfPeople.vue?vue&type=script&lang=js&"
export * from "./NumberOfPeople.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfPeople.vue?vue&type=style&index=0&id=f06103f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06103f0",
  null
  
)

export default component.exports